import i18n from '../../../../../base-dictionary';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setRelatedTasksFilterHideEmpty,
  setRelatedTasksFilterSearchTerm,
  setRelatedTasksFilterSortBy,
  setRelatedTasksFilterSortDirection,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { FilterListControls } from '../../components/filters-list/filters-list-controls';
import { getFilterOptions, getSortOptions } from '../../initiative-performance.helpers';
import type { EpicSortOption } from '../../initiative-performance.type';
import { RelatedTasksMode } from '../related-tasks-tab.type';

export const FiltersSearch = () => {
  const mode = useRelatedTasksTabStore((state) => state.mode);
  const searchTerm = useRelatedTasksTabStore((state) => state.filterControls.searchTerm);
  const sortBy = useRelatedTasksTabStore((state) => state.filterControls.sortBy);
  const sortDirection = useRelatedTasksTabStore((state) => state.filterControls.sortDirection);
  const hideEmpty = useRelatedTasksTabStore((state) => state.filterControls.hideEmpty);

  if (mode !== RelatedTasksMode.ContributingEpics) {
    return null;
  }

  return (
    <FilterListControls
      searchTerm={searchTerm}
      onSearchChange={(value) => setRelatedTasksFilterSearchTerm(value)}
      searchPlaceholder={i18n.t('strategy.filters.search_by_epic')}
      sortOptions={getSortOptions()}
      selectedSort={sortBy}
      onSortChange={(value) => setRelatedTasksFilterSortBy(value as EpicSortOption)}
      sortDirection={sortDirection}
      onSortDirectionChange={(direction) => setRelatedTasksFilterSortDirection(direction)}
      filterOptions={getFilterOptions()}
      selectedFilters={{ hideEmpty }}
      onFilterChange={(filterOption: string, value: boolean) => {
        if (filterOption === 'hideEmpty') {
          setRelatedTasksFilterHideEmpty(value);
        }
      }}
    />
  );
};
